module.exports = __webpack_public_path__ + "static/media/companyHub-register.ad4087a5.png";